import React, { useRef, useState, useEffect, useMemo } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { QMS } from "../../../_constants/actionConstants";
import cmtIssueActions from "../../../_actions/_qmsActions/cmtIssueActions";

export default function CmtModal_AcknowledgeIssue(props) {
  const { modalState, toggleModal } = props;

  const dispatch = useDispatch();

  const fetching = useSelector((state) => state.qms.fetching);

  const [acknowledgmentRemarks, setAcknowledgedRemarks] = useState("");
  const [isNotDivisionOwnedProcess, setIsNotDivisionOwnedProcess] = useState(false);

  const handleClick_open = async (e) => {
    e.preventDefault();
    dispatch({
      type: QMS.ISSUE.UPDATE_CLIENT,
      issueId: modalState.data.issueId,
      fieldsToUpdate: {
        isAcknowledged: true,
        acknowledgedByQmsUserId: modalState.data.qmsUserId,
        acknowledgmentRemarks,
        isNotDivisionOwnedProcess,
      },
    });
    await dispatch(cmtIssueActions.acknowledge(modalState.data.issueId));
    dispatch(cmtIssueActions.getAll(modalState.data.divisionId));
    toggleModal();
  };

  const closeBtn = (
    <button className="close" onClick={toggleModal}>
      <FontAwesomeIcon icon="times" className="fa-fw text-white" />
    </button>
  );

  return (
    <Modal isOpen={modalState.showModal} toggle={toggleModal} fade={false} size={"md"}>
      <ModalHeader toggle={toggleModal} className="bg-info text-white" close={closeBtn}>
        <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
        Acknowledge Issue
      </ModalHeader>
      <ModalBody>
        <div className="form-row form-group mb-2">
          <label htmlFor="acknowledgmentRemarks" className="mb-0 font-weight-bold">
            Remarks/Notes:
          </label>
          <textarea
            id="acknowledgmentRemarks"
            name="acknowledgmentRemarks"
            className="form-control"
            onChange={(e) => setAcknowledgedRemarks(e.target.value)}
            rows={4}
          />
        </div>
        <div className="form-row form-group mb-0">
          <div className="custom-control-inline custom-control custom-checkbox">
            <input
              type="checkbox"
              name="isNotDivisionOwnedProcess"
              id="isNotDivisionOwnedProcess"
              className="custom-control-input my-auto"
              value={isNotDivisionOwnedProcess}
              checked={isNotDivisionOwnedProcess}
              onChange={(e) => setIsNotDivisionOwnedProcess(e.target.checked)}
            />
            <label
              htmlFor="isNotDivisionOwnedProcess"
              className="custom-control-label my-auto"
            >
              This is a process that is NOT owned by this division
            </label>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="form-group form-row float-right mb-0">
          <button
            type="button"
            name="open"
            id="open"
            className="btn btn-primary mr-2"
            onClick={handleClick_open}
          >
            {fetching && (
              <span className="mr-2 mt-1">
                <FontAwesomeIcon
                  icon="spinner"
                  className="loading-spinner"
                  style={{ color: "white" }}
                />
              </span>
            )}
            <b>Submit</b>
          </button>
          <button
            type="button"
            name="cancel"
            id="cancel"
            className="btn btn-secondary"
            onClick={toggleModal}
          >
            Cancel
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
